import React, {FormEvent} from "react";
import {serializeForm, submitForm} from "@sitecore-jss/sitecore-jss-forms";
import {Form} from "@sitecore-jss/sitecore-jss-react-forms";
import {connect} from "react-redux";
import {
  updateFields,
  setLoader,
  updateRemoveError,
  updateCustomError,
} from "../../../ReduxImpl/actions/index";
import {trackWithGoogleTagManager} from "../../../../../utils/analytics";
import i18next from "i18next";

export interface FieldState {
  value?: string | string[] | File[] | boolean;
  isValid: boolean;
  errors: string[];
}

export interface FieldStateCollection {
  [key: string]: FieldState;
}

class JssForm extends Form {
  //delay scrolling
  delayScroll(time = 2000) {
    setTimeout(() => {
      window.scroll(0, 0);
    }, time);
  }

  getCookieValue(name) {
    let result =
      typeof document != "undefined"
        ? document.cookie.match("(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)")
        : null;
    return result ? result.pop() : "";
  }

  toggleError() {
    const errorIcon =
      typeof document != "undefined"
        ? document.getElementById("form-error-icon")
        : null;
    if (errorIcon) {
      errorIcon.style.color = "#e41e2d";
    }
  }

  showError(errors) {
    // DEBUG
    const node = document.querySelector(".engine_validation_error_section");

    const updateInnerHTML = (errors, node) => {
      node.innerHTML = `<ul style="background: #e41e2d;color: white;padding: 24px 32px;margin: 0">${errors
        .map((e) => `<li>${e}</li>`)
        .join("")}</ul>`;
    };

    if (node) {
      node.classList.remove("d-none");
      updateInnerHTML(errors, node);
    }
  }

  /**
   * Handler triggered when the form is submitted. May transition its state between
   * steps in a multistep form or handle a final submit.
   * @param {FormEvent} e
   */
  onSubmit(e: FormEvent) {
    e.preventDefault();

    let jssForm: any = this.props;
    jssForm.setLoader(true);

    let rError: any = this.props;
    rError.updateRemoveError(true);

    let cError: any = this.props;
    cError.updateCustomError("");

    const form = this.state.nextForm || this.props.form;

    const fieldValues: {[key: string]: string | string[] | boolean | File[]} =
      {};

    const currentFieldValues = this.collectCurrentFieldValues();

    currentFieldValues.forEach((field) => {
      if (typeof field.state.value !== "undefined") {
        fieldValues[field.fieldName] = field.state.value;
      }
    });

    // NOTE: we're not pre-validating the submit on the client because
    // Sitecore won't be able to track validation errors in xConnect

    // serialize the form data that we got from the server
    // (hidden fields with constant values, unchanged default field values, etc)
    const formData = serializeForm(form, {
      submitButtonName: this.state.submitButton,
    });
    // merge in user-updated field values
    formData.mergeOverwritingExisting(fieldValues);

    // const context = useSitecoreContext();

    const submitUrl =
      (e.target as HTMLFormElement).action +
      "&sc_lang=" +
      (i18next.language === "cn" ? "zh" : i18next.language);

    if (!submitUrl) {
      throw new Error(
        "Submit URL was not defined. Ensure the form has an action attribute."
      );
    }

    const manageConsentPopup: (event: string, id: string) => void = (
      event,
      id
    ) => {
      if (
        typeof document != "undefined" &&
        document.querySelectorAll(".pending--consent").length === 0
      ) {
        trackWithGoogleTagManager({
          event: `event_${event}`,
          eventCategory: event,
          eventAction: `${event}_subscribe`,
          eventLabel: "subscription",
        });
        const popup = document.getElementById(id);

        popup.classList.add(`${id}--visible`);
        popup.classList.add("pending--consent");
      } else {
        trackWithGoogleTagManager({
          event: `event_${event}`,
          eventCategory: event,
          eventAction: `${event}_submit`,
          eventLabel: "subscription",
        });
        if (typeof document != "undefined") {
          document.getElementById(id).classList.remove("pending--consent");
        }
      }
    };
    submitForm(formData, submitUrl, {fetcher: this.props.formFetcher})
      .then((result) => {
        if (result.errors.length > 0) {
          this.toggleError();
          this.showError(result.errors);
        } else if (result.success) {
          setTimeout(() => {
            if (typeof document != "undefined") {
              if (document.querySelectorAll(".newsletter-form").length > 0) {
                // Newsletter
                manageConsentPopup("newsletter", "NewsletterFormModalPopup");
              } else if (
                document.querySelectorAll(".contact-us-form").length > 0
              ) {
                // Contact Us
                manageConsentPopup("contactus", "ContactUsFormModalPopup");
              } else if (
                document.querySelectorAll(".appointment-form").length > 0
              ) {
                // Appointment
                manageConsentPopup("appointment", "AppointmentFormModalPopup");
              }
            }
          }, 100);

          if (result.redirectUrl) {
            // Process redirect-on-success action.
            if (this.props.onRedirect) {
              this.props.onRedirect(result.redirectUrl);
              //this.delayScroll()
            } else {
              window.location.href = result.redirectUrl;
              /// this.delayScroll()
            }
          }
        } else {
          this.toggleError();
        }

        let ErrorElToBeFocused: string;

        if (
          result.validationErrors &&
          Object.keys(result.validationErrors).length > 0
        ) {
          //setLoader(false);
          const stateUpdate: FieldStateCollection = {};

          Object.keys(result.validationErrors).forEach((fieldKey) => {
            if (!ErrorElToBeFocused) ErrorElToBeFocused = fieldKey;

            stateUpdate[fieldKey] = {
              value: (this.state[fieldKey] || {}).value,

              isValid: false,

              errors: result.validationErrors[fieldKey],
            };
          });
          //sets the Frist Error Element on form after submit.

          this.setState(stateUpdate, () => {
            const fieldEl: HTMLElement =
              typeof document != "undefined"
                ? document.querySelector("*[name='" + ErrorElToBeFocused + "']")
                : null;

            fieldEl?.focus();
          });
        }

        if (result.nextForm) {
          let sampleProps: any = this.props;
          sampleProps.updateFields(result.nextForm);
          //this.setState({ nextForm: result.nextForm });
        }

        if (result.success) {
          this.resetFieldsState();
        }
        // checks for email address already exits -> subscribe form
        if (
          result.success &&
          result.redirectUrl === null &&
          result.validationErrors &&
          Object.keys(result.validationErrors).length > 0
        ) {
          // throw result.errors
          rError.updateRemoveError(true);
          window.scroll(0, 0);
          throw result.errors[0];
        }

        if (result.errors && result.errors.length > 0) {
          throw result.errors;
        }

        jssForm.setLoader(false);
        this.setState({errors: []});
      })
      .catch((error: Error | string[] | string) => {
        this.toggleError();
        document.querySelectorAll(".show_error").forEach((el) => {
          if (el) {
            const input = el.querySelector("input");
            if (input) {
              input.classList.add("error");
            }
          }
        });

        window && window.scrollTo && window.scrollTo(0, 0);
        //console.log(error);
        if (Array.isArray(error)) {
          this.setState({errors: error});
        } else if (typeof error === "string") {
          //TODO:
          // var wrapper = document.createElement("div")
          // var p = document.createElement("span")
          // var icon = document.createElement("pfe-icon")
          // icon.setAttribute("icon", "ivg-alert-triangle-line")
          // icon.setAttribute("size", "14")
          // icon.setAttribute(
          //   "class",
          //   "sitecore-jss-form__error-list__icon PFElement"
          // )
          // wrapper.setAttribute("class", "sitecore-jss-form__error-list error")
          // p.innerHTML = error
          // wrapper.appendChild(icon)
          // wrapper.appendChild(p)
          // document
          //   .getElementsByClassName(
          //     "sitecore-jss-form__control--emailTextbox"
          //   )[0]
          //   .appendChild(wrapper)
          cError.updateCustomError(error);

          this.setState({errors: [error]});
        } else {
          this.setState({errors: [error.message]});
        }

        jssForm.setLoader(false);
        rError.updateRemoveError(true);
      });
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateFields: (fields) => dispatch(updateFields(fields)),
    setLoader: (val) => dispatch(setLoader(val)),
    updateRemoveError: (v) => dispatch(updateRemoveError(v)),
    updateCustomError: (c) => dispatch(updateCustomError(c)),
  };
};

export default connect(null, mapDispatchToProps)(JssForm);
